export default __webpack_public_path__ + "static/media/illustration-woman-online-desktop.843eb114.svg";